/**
 * PriceRange is a custom HTMLElement that represents a dual-input price range selector.
 * This element ensures that the value of the "min" input is always less than or equal to the "max" input, and vice versa.
 */
class PriceRange extends HTMLElement {
  constructor() {
    super()

    // Add 'change' event listener to each input element
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    )

    this.setMinAndMaxValues()
  }

  /**
   * Handle the change event for the range inputs and adjust their values accordingly.
   * @param {Event} event - The change event object.
   */
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  /**
   * Adjust the "min" and "max" attributes of each input based on the current values.
   */
  setMinAndMaxValues() {
    const [minInput, maxInput] = this.querySelectorAll('input')

    if (maxInput.value) {
      minInput.setAttribute('max', maxInput.value)
    } else {
      minInput.setAttribute('max', maxInput.getAttribute('max'))
    }

    if (minInput.value) {
      maxInput.setAttribute('min', minInput.value)
    } else {
      maxInput.setAttribute('min', 0)
    }
  }

  /**
   * Adjust the value of the input to ensure it lies within the valid range.
   * @param {HTMLInputElement} input - The input element to adjust.
   */
  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min') || 0)
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

// Register the custom element 'price-range'
customElements.define('price-range', PriceRange)
